import { uploadUrl } from "../../lib/assets";

/**
 * @param {{ project: import("../../data/projects").PROJECTS[0], onOpen: (id: string) => void, index: number }} props
 */
export default function ProjectTile({ project, onOpen, index }) {
  return (
    <article
      className={`project-tile${project.big ? " project-tile--featured" : ""}`}
      style={{ animationDelay: `${index * 0.06}s` }}
      onClick={() => onOpen(project.id)}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onOpen(project.id);
        }
      }}
      role="button"
      tabIndex={0}
      aria-label={`View project: ${project.title}`}
    >
      <div
        className="project-tile__image"
        style={{ backgroundImage: `url('${uploadUrl(project.img)}')` }}
      />
      <div className="project-tile__scrim" />
      <span className="project-tile__pill">{project.count}</span>

      <div className="project-tile__body">
        <div className="project-tile__meta">
          <span>{project.cat.toUpperCase()}</span>
          <span className="project-tile__meta-rule" />
          <span>{project.year}</span>
        </div>
        <h2 className={`project-tile__title${project.big ? " project-tile__title--featured" : ""}`}>
          {project.title}
        </h2>
        <p className="project-tile__dek">{project.dek}</p>
        <div className="project-tile__cta">
          VIEW PROJECT <span aria-hidden="true">→</span>
        </div>
      </div>
    </article>
  );
}
